import { Divider, Tabs } from "antd"
import { Content } from "antd/es/layout/layout"
import TaxCodeInfo from "./TaxCodeInfo"
import InvoiceInfo from "./InvoiceInfo"
import { memo } from "react"
import { SearchSingleFormModel } from "../../../../../model/searchInvoiceModels"

const SearchInformation: React.FC<{ header: string, formValues: SearchSingleFormModel }>
    = ({ header, formValues }) => {
        return (<Content>
            <Divider></Divider>
            <Tabs items={[
                {
                    key: "thong-tin-hoa-don",
                    label: `Thông tin ${header}`,
                    children: (<InvoiceInfo taxCode={formValues.taxCode} securityCode={formValues.securityCode} />)
                },
                {
                    key: "thong-tin-nguoi-ban",
                    label: "Thông tin người bán",
                    children: (<TaxCodeInfo taxCode={formValues.taxCode} />),
                },
            ]}>
            </Tabs>
        </Content>)
    }
export default memo(SearchInformation)